import PropTypes from 'prop-types';

const RequirementTemplateType = PropTypes.shape({
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  creatorId: PropTypes.number,
  creator: {
    userFirstName: PropTypes.string,
    userLastName: PropTypes.string
  },
  updatedAt: PropTypes.oneOfType([PropTypes.instanceOf(Date), PropTypes.string]),
  publishedAt: PropTypes.oneOfType([PropTypes.instanceOf(Date), PropTypes.string]),
  archivedAt: PropTypes.oneOfType([PropTypes.instanceOf(Date), PropTypes.string]),
  createdAt: PropTypes.oneOfType([PropTypes.instanceOf(Date), PropTypes.string]),
  name: PropTypes.string,
  description: PropTypes.string,
  requirementTemplateFolderId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  requirementTemplateBlocks: PropTypes.arrayOf(PropTypes.shape({}))
});

export default RequirementTemplateType;
